module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-731-retro.34825023.jpg";